module.exports = __webpack_public_path__ + "static/media/antic-home.58f01ab1.jpg";